import React from 'react';
import moment from 'moment';
import constants from "../../../utils/constants.js";

const columns = [
	{
		id: 'name',
		name: 'Name',
		sortable: true,
		selector: row => row.name,
		cell: row => row.name,
		width: '300px'
	}, {
		id: 'comments',
		name: 'Comments',
		sortable: true,
		selector: row => row.comments,
		cell: row => <div title={row.comments} style={{overflow: 'hidden', textOverflow: 'ellipsis'}}>{row.comments}</div>,
		width: '300px'
	}, {
		id: 'type',
		name: 'Type',
		sortable: true,
		selector: row => row.type,
		cell: row => row.type === 'Live' ? <span style={{color: 'green'}}>{row.type}</span> : row.type,
		width: '120px'
	}, {
		id: 'status',
		name: 'Status',
		sortable: true,
		selector: row => row.status,
		cell: row => row.status === 'available' ? row.status : <span style={{color: 'red'}}>{row.status}</span>,
		width: '120px'
	}, {
		id: 'created_by',
		name: 'Created By',
		sortable: true,
		selector: row => row.created_by,
		cell: row => row.created_by,
		width: '170px'
	}, {
		id: 'created_at',
		name: 'Created At',
		sortable: true,
		selector: row => row.created_at,
		cell: row => moment(row.created_at).format(constants.DATETIME_FOTMAT),
		width: '150px'
	}, {
		id: 'actions',
		name: 'Actions',
		width: '300px'
	}
];

export default columns;
